import { FC } from "react";
import SuperCascader from '../SuperCascader';
import SearchFormItem from './subpage/searchFormItem';
import { getSelectPlaceholder } from "../utils/ruleUtils";
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { SuperCascaderProps } from '../SuperCascader/interface';

export interface SearchFormCascaderProps extends BaseSearchFormItemProps {
  cascaderProps?: SuperCascaderProps;
};
/** 下拉分类 */
const SearchFormCascader: FC<SearchFormCascaderProps> = props => {
  const { isDetail, name, label, rules, cascaderProps, disabledRender, ...restProps } = props;
  const normFile = (e: any) => {
    if (cascaderProps?.multiple) {
      return e.map?.((item: any) => item?.slice?.(-1)?.[0])
    }
    if (e && e.length) return e.slice?.(-1)?.[0];
    return undefined;
  };
  return (
    <SearchFormItem
      name={name}
      {...restProps}
      label={label}
      rules={rules}
      valuePropName="cascaderValue"
      getValueFromEvent={normFile}
      validateTrigger="onChange"
    >
      <SuperCascader
        {...cascaderProps}
        isDetail={true}
        disabled={isDetail || cascaderProps?.disabled}
        disabledRender={disabledRender}
        placeholder={getSelectPlaceholder(label, cascaderProps, rules)}
      />
    </SearchFormItem>
  );
};

SearchFormCascader.displayName = SearchFormItemEnum.SearchFormCascader;

export default SearchFormCascader;
